import React, { useEffect, useRef } from "react"
import { Row, Col, Form, Button } from "reactstrap"
import Select from "react-select"
import { Slider } from "primereact/slider"
import { InputText } from "primereact/inputtext"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { useTranslation } from "react-i18next"

const ItemFilter = ({
  filters,
  searchTerm,
  handleSearchChange,
  handleFilterChange,
  handleSearch,
  onReset = () => {},
  selectedFilters,
  isRangeSlider,
  priceRange,
  setPriceRange,
  hideSearch,
  isRangeDate,
  dateRange,
  searchBy,
  setDateRange,
}) => {
  const { t } = useTranslation()

  const prevSearchTermRef = useRef("")

  const handleSearchClick = () => {
    handleSearch()
  }

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === "Enter") {
        e.preventDefault()
        handleSearch() // Trigger search
      }
    }

    window.addEventListener("keydown", handleKeyDown)

    return () => {
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [handleSearch])

  useEffect(() => {
    if (prevSearchTermRef.current !== "" && searchTerm.trim() === "") {
      handleSearch() // Trigger search only when searchTerm is cleared
    }

    prevSearchTermRef.current = searchTerm // Update previous value
  }, [searchTerm])

  return (
    <Form>
      <Row className="mb-3 pb-3 border-bottom">
        {hideSearch ? null : (
          <Col lg={4} className="mt-3">
            <div className="d-flex position-relative">
              <input
                name="search"
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder={` ${searchBy ? searchBy : " Keyword"}`}
                title={` ${searchBy ? searchBy : " Keyword"}`}
                className="ps-4 form-control"
              />
              <i
                className="bx bx-search-alt-2"
                style={{
                  position: "absolute",
                  left: 16,
                  fontSize: 20,
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  opacity: "0.9",
                }}
              ></i>
            </div>
          </Col>
        )}
        {filters.map((filter, index) => (
          <Col key={index} lg={4} className="mt-3">
            {filter.type === "select" && (
              <select
                className="form-select"
                value={selectedFilters[filter.name]}
                onChange={e => handleFilterChange(e.target.value, filter.name)}
              >
                <option hidden>{filter.placeholder}</option>
                {filter.options.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            )}
            {filter.type === "multiSelect" && (
              <Select
                value={selectedFilters[filter.name]}
                isMulti={true}
                onChange={selectedOption => {
                  handleFilterChange(selectedOption, filter.name)
                }}
                options={filter.options}
                placeholder={filter.placeholder}
                className="select2-selection"
                closeMenuOnSelect={false}
              />
            )}
            {filter.type === "singleSelect" && (
              <Select
                value={selectedFilters[filter.name]}
                isMulti={false}
                onChange={selectedOption => {
                  handleFilterChange(selectedOption, filter.name)
                }}
                options={filter.options}
                placeholder={filter.placeholder}
                className="select2-selection"
              />
            )}
          </Col>
        ))}
        {isRangeDate && (
          <Col lg={4} className="mt-3">
            <Flatpickr
              className="form-control d-block"
              placeholder="YYYY-MM-DD"
              options={{
                mode: "range",
                dateFormat: "Y-m-d",
                // defaultDate: [new Date("2024-05-01"), new Date("2024-05-21")],
              }}
              onChange={selectedDates => {
                const formattedDates = selectedDates.map(
                  date =>
                    date
                      .toLocaleDateString("en-CA", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                      .split("/")
                      .reverse()
                      .join("-") // Format to "yyyy-mm-dd"
                )
                const minDate = formattedDates[0]
                const maxDate = formattedDates[1]
                setDateRange({
                  min: minDate,
                  max: maxDate,
                })
              }}
            />
          </Col>
        )}

        {isRangeSlider && (
          <Col lg={4} style={{ marginTop: 16 }}>
            <div className="">
              <InputText
                value={priceRange[0]}
                onChange={e => {
                  const newValue = parseInt(e.target.value)
                  // if (!isNaN(newValue)) {
                  setPriceRange([
                    // Math.min(Math.max(newValue, 0), 1000),
                    newValue,
                    priceRange[1],
                  ])
                  // }
                }}
                style={{ width: "46%", marginRight: "2%" }}
                type="number"
                placeholder="Search range"
              />
              <InputText
                value={priceRange[1]}
                type="number"
                style={{ width: "46%", marginLeft: "2%" }}
                onChange={e => {
                  const newValue = parseInt(e.target.value)
                  if (!isNaN(newValue)) {
                    setPriceRange([priceRange[0], Math.min(newValue, 1000)])
                  }
                }}
                className="w-50"
                placeholder="Search range"
              />
              {/* <Slider
                value={priceRange}
                onChange={e => setPriceRange([e.value[0], e.value[1]])}
                className="w-full"
                range
                min={0}
                max={1000}
              /> */}
            </div>
          </Col>
        )}

        <Col lg={4} style={{ marginTop: 16 }}>
          <div className="d-flex justify-content-start gap-3">
            <Button
              color="success"
              onClick={handleSearchClick}
              className="g_center d-flex w-50"
              style={{ minWidth: 40, height: 39, padding: "0 10px" }}
            >
              <i className="bx bx-search-alt-2" style={{ fontSize: 22 }}></i>{" "}
              {t("Search")}
            </Button>
            <Button
              color="success"
              onClick={onReset}
              className="g_center d-flex btn-light w-50"
              style={{ minWidth: 40, height: 39, padding: "0 10px" }}
            >
              <i className="mdi mdi-refresh me-1" style={{ fontSize: 22 }}></i>{" "}
              {t("Reset")}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default ItemFilter
